module.exports = __webpack_public_path__ + "static/nursery-613fe75f1482135bd050ea123d13672e.png";